import React, { useState, useEffect } from "react";
import Select from 'react-select';
import "./Modal.css";

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  fields = [], 
  onSubmit, 
  message = "", 
  mode = "create",
}) => {
  // Initialize formData outside of conditions
  const [formData, setFormData] = useState({});

  // Sync form data with fields (e.g., for Edit mode)
  useEffect(() => {
    const initialFormData = fields.reduce((acc, field) => {
      acc[field.name] = field.value || "";
      return acc;
    }, {});
    setFormData(initialFormData);
  }, [fields]);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormData(prev => ({
      ...prev,
      [name]: selectedOption.value
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content form-wrapper" onClick={(e) => e.stopPropagation()}>
        <h2 style={{margin: "0px"}}>{title}</h2>

        {/* Handle Delete Confirmation */}
        {mode === "delete" ? (
          <p>{`${message} ${fields[1].value}`}</p>
        ) : (
          <form onSubmit={handleSubmit}>
            {fields.map((field, index) => (
              <div 
                key={index} 
                className={`${field.hidden ? 'hidden-field' : 'form-group'}`}
              >
                {!field.hidden && <label htmlFor={field.name}>{field.label}</label>}
                {field.type === "dropdown" ? 
                <Select 
                  id={field.name}
                  name={field.name}
                  value={{
                    value: formData[field.name],
                    label: field.dropdownOptions.find(r => r.id === formData[field.name])?.name
                  }}
                  options={field.dropdownOptions.map(e => ({label: e.name, value: e.id}))}
                  onChange={handleSelectChange}
                  closeMenuOnSelect={true}
                  required={field.required || false} 
                />
                : 
                <input
                  id={field.name}
                  name={field.name}
                  value={
                    field.type === "datetime"
                      ? (formData[field.name] ? formData[field.name].slice(0, 16) : "")
                      : (formData[field.name] || "")
                  }
                  onChange={handleChange}
                  type={field.hidden ? "hidden" : (field.type === "datetime" ? "datetime-local" : field.type || "text")}
                  placeholder={field.placeholder || ""}
                  required={field.required || false}
                  className="form-input"
                />}
              </div>
            ))}
          </form>
        )}

        <div className="modal-actions">
          <button type="button" onClick={onClose} className="modal-cancel-button">
            Cancel
          </button>
          <button type="submit" className={mode === "delete" ? "modal-delete-button" : "modal-submit-button"} onClick={handleSubmit}>
            {mode === "delete" ? "Delete" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;